import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Timeline, Empty, Popconfirm, Button, Drawer } from 'antd';
import dayjs from 'dayjs';
import { LoadingOutlined, DownOutlined, DeleteOutlined, EditOutlined, CheckOutlined, CheckSquareFilled, RightSquareFilled, HistoryOutlined } from '@ant-design/icons';
import H3Text from '@Uilib/h3Text';
import ActivityLogActions from '@Actions/activityLogActions';
import messageIcon from '@Images/icons/icon-paper-plane.png';
import messageIcon2 from '@Images/icons/icon-message.png';
import H3Image from '@Uilib/h3Image';
import H3FormInput from '@Uilib/h3FormInput';
import './style.scss';
import HistoryLog from './HistoryLog';

class ActivityLog extends Component {

  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      limit: 10,
      logComment: '',
      hover: '',
      edit: '',
      inputValue: '',
      setOpen: false,
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.entityId && props.entityType && !state.isUserReady) {
      props.getActivityLog(props.entityId, props.entityType, state.page, state.limit, () => { }, props?.subEntityId);
      return {
        ...state,
        isUserReady: true,
      };
    }
    return state;
  }

  addActivityLog() {
    const {
      addActivityLog, entityType, entityId, user, getActivityLog,
    } = this.props;
    const { logComment, page, limit } = this.state;
    const payload = {
      entity_name: entityType,
      entity_id: entityId,
      org_id: user?.tenant_info?.org_id,
      log: {
        log_category: 'COMMENT',
        action: 'COMMENTED',
        entity_id: entityId,
        message: logComment,
        modified_by_info: {
          tenant_id: user?.tenant_info?.tenant_id,
          is_active: true,
          department_id: user?.department_id,
          login_with_email: user?.login_with_email,
          mobile: user?.mobile,
          last_name: user?.last_name,
          tenant_role_id: user?.tenant_role_id,
          user_id: user?.user_id,
          role_id: user?.role_id,
          org_id: user?.org_id,
          designation: user?.designation,
          first_name: user?.first_name,
          login_with_phone: true,
          email: user?.email,
          username: user?.username,
        },
      },
    };
    addActivityLog(payload, () => {
      this.setState({ page: 1 });
      getActivityLog(entityId, entityType, 1, limit, () => {
        this.setState({ logComment: '' });
      });
    });
  }

  editActivityLog(id) {
    const {
      editActivityLog, entityType, entityId, getActivityLog,
    } = this.props;
    const { page, limit } = this.state;
    const {
      inputValue,
    } = this.state;
    const payload = {
      entity_name: entityType,
      entity_id: entityId,
      id,
      message: inputValue,

    };
    editActivityLog(payload, () => {
      getActivityLog(entityId, entityType, 1, limit, () => {
        this.setState({ edit: '' });
      });
    });
  }

  getDataSource() {
    const {
      entityType, activityLogPR, activityLogPO, activityLogGRN, activityLogSO, activityLogInvoice, activityLogCO, activityLogMO, activityLogVendorPayout, activityLogStockTransfer, activityLogDebitNote, activityLogCreditNote, activityLogReturnSlip, activityLogEstimate, activityLogProduct, activityLogPackingSlip, activityLogGateDocument, activityOfferLogProduct, activityLogAPInvoice, activityLogAMC, activityLogPI, activityLogDeliveryChallan,
    } = this.props;

    if (entityType === 'purchase_requisition') {
      const activityLog = activityLogPR;
      return activityLog;
    }
    if (entityType === 'purchase_indent') {
      const activityLog = activityLogPI;
      return activityLog;
    }
    if (entityType === 'purchase_order') {
      const activityLog = activityLogPO;
      return activityLog;
    }
    if (entityType === 'good_receiving_note') {
      const activityLog = activityLogGRN;
      return activityLog;
    }
    if (entityType === 'sales_order') {
      const activityLog = activityLogSO;
      return activityLog;
    }
    if (entityType === 'annual_maintenance_contract') {
      const activityLog = activityLogAMC;
      return activityLog;
    }
    if (entityType === 'invoice') {
      const activityLog = activityLogInvoice;
      return activityLog;
    }
    if (entityType === 'consumption_order') {
      const activityLog = activityLogCO;
      return activityLog;
    }
    if (entityType === 'manufacturing_order') {
      const activityLog = activityLogMO;
      return activityLog;
    }
    if (entityType === 'vendor_payout') {
      const activityLog = activityLogVendorPayout;
      return activityLog;
    }
    if (entityType === 'stock_transfer') {
      const activityLog = activityLogStockTransfer;
      return activityLog;
    }
    if (entityType === 'debit_note') {
      const activityLog = activityLogDebitNote;
      return activityLog;
    }
    if (entityType === 'credit_note') {
      const activityLog = activityLogCreditNote;
      return activityLog;
    }
    if (entityType === 'return_slip') {
      const activityLog = activityLogReturnSlip;
      return activityLog;
    }
    if (entityType === 'sales_estimate') {
      const activityLog = activityLogEstimate;
      return activityLog;
    }
    if (entityType === 'packing_slip') {
      const activityLog = activityLogPackingSlip;
      return activityLog;
    }
    if (entityType === 'gate_document') {
      const activityLog = activityLogGateDocument;
      return activityLog;
    }
    if (entityType === 'product') {
      const activityLog = activityLogProduct;
      return activityLog;
    }
    if (entityType === 'sku_offer') {
      const activityLog = activityOfferLogProduct;
      return activityLog;
    }
    if (entityType === 'account_payable_invoice') {
      const activityLog = activityLogAPInvoice;
      return activityLog;
    }
    if (entityType === 'delivery_challan') {
      const activityLog = activityLogDeliveryChallan;
      return activityLog;
    }
    return {};
  }

  getActivityLogLoading() {
    const {
      entityType, getActivityLogPRLoading, getActivityLogPOLoading, getActivityLogGRNLoading, getActivityLogSOLoading, getActivityLogInvoiceLoading, getActivityLogCOLoading, getActivityLogMOLoading, getActivityLogVendorPayoutLoading, getActivityLogStockTransferLoading, getActivityLogDebitNoteLoading, getActivityLogCreditNoteLoading, getActivityLogReturnSlipLoading, getActivityLogEstimateLoading, getActivityLogProductLoading, getActivityOfferLogProductLoading, getActivityLogPackingSlipLoading, getActivityLogGateDocumentLoading, getActivityLogAMCLoading, getActivityLogPILoading, getActivityLogAPInvoiceLoading, getActivityLogDeliveryChallanLoading,
    } = this.props;
    if (entityType === 'purchase_requisition') {
      const getActivityLogLoading = getActivityLogPRLoading;
      return getActivityLogLoading;
    }
    if (entityType === 'purchase_indent') {
      const getActivityLogLoading = getActivityLogPILoading;
      return getActivityLogLoading;
    }
    if (entityType === 'purchase_order') {
      const getActivityLogLoading = getActivityLogPOLoading;
      return getActivityLogLoading;
    }
    if (entityType === 'good_receiving_note') {
      const getActivityLogLoading = getActivityLogGRNLoading;
      return getActivityLogLoading;
    }
    if (entityType === 'account_payable_invoice') {
      const getActivityLogLoading = getActivityLogAPInvoiceLoading;
      return getActivityLogLoading;
    }
    if (entityType === 'sales_order') {
      const getActivityLogLoading = getActivityLogSOLoading;
      return getActivityLogLoading;
    }
    if (entityType === 'annual_maintenance_contract') {
      const getActivityLogLoading = getActivityLogAMCLoading;
      return getActivityLogLoading;
    }
    if (entityType === 'invoice') {
      const getActivityLogLoading = getActivityLogInvoiceLoading;
      return getActivityLogLoading;
    }
    if (entityType === 'consumption_order') {
      const getActivityLogLoading = getActivityLogCOLoading;
      return getActivityLogLoading;
    }
    if (entityType === 'manufacturing_order') {
      const getActivityLogLoading = getActivityLogMOLoading;
      return getActivityLogLoading;
    }
    if (entityType === 'vendor_payout') {
      const getActivityLogLoading = getActivityLogVendorPayoutLoading;
      return getActivityLogLoading;
    }
    if (entityType === 'stock_transfer') {
      const activityLog = getActivityLogStockTransferLoading;
      return activityLog;
    }
    if (entityType === 'debit_note') {
      const activityLog = getActivityLogDebitNoteLoading;
      return activityLog;
    }
    if (entityType === 'credit_note') {
      const activityLog = getActivityLogCreditNoteLoading;
      return activityLog;
    }
    if (entityType === 'return_slip') {
      const activityLog = getActivityLogReturnSlipLoading;
      return activityLog;
    }
    if (entityType === 'sales_estimate') {
      const activityLog = getActivityLogEstimateLoading;
      return activityLog;
    }
    if (entityType === 'packing_slip') {
      const activityLog = getActivityLogPackingSlipLoading;
      return activityLog;
    }
    if (entityType === 'gate_document') {
      const activityLog = getActivityLogGateDocumentLoading;
      return activityLog;
    }
    if (entityType === 'product') {
      const activityLog = getActivityLogProductLoading;
      return activityLog;
    }
    if (entityType === 'sku_offer') {
      const activityLog = getActivityOfferLogProductLoading;
      return activityLog;
    }
    if (entityType === 'delivery_challan') {
      const activityLog = getActivityLogDeliveryChallanLoading;
      return activityLog;
    }
    return true;
  }

  render() {
    const {
      getActivityLog, entityType, entityId, addActivityLogLoading, editActivityLogLoading, user, subEntityId, disableComments, entityName,
    } = this.props;
    const {
      loadMore, page, limit, logComment, hover, edit, inputValue, setOpen,
    } = this.state;
    return (
      <Fragment>
        <div className="view__activity-log">
          {!disableComments && (
            <>
              <H3Text text="Activity Log" className="view__activity-log-title" />
              <div className="activity-log__comment">
                <div style={{ display: 'flex' }}>
                  <input
                    value={logComment}
                    className="activity-log__comment-input"
                    onChange={(event) => this.setState({ logComment: event.target.value })}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && logComment?.trim()) {
                        this.addActivityLog();
                      }
                    }}
                    placeholder="Add comments here..."
                    disabled={this.getActivityLogLoading() || addActivityLogLoading}
                  />
                  <H3Image
                    src={messageIcon}
                    className="activity-log__comment-button"
                    onClick={() => {
                      if (logComment?.trim()) {
                        this.addActivityLog();
                      }
                    }}
                  />
                </div>
              </div>
            </>
          )}
          {(this.getActivityLogLoading() || addActivityLogLoading) && (
            <div className="view__activity-log-loader">
              Loading...&nbsp;
              <div className="view__activity-log-loader__icon">
                <LoadingOutlined />
              </div>
            </div>
          )}
          {(this.getDataSource()?.data?.length > 0) ? (
            <Fragment>

              <Timeline>
                {
                  this.getDataSource()?.data?.filter((item) => !item?.ignore)?.map((item) => (
                    <Timeline.Item
                      key={item?.log_id}
                      onMouseEnter={() => this.setState({ hover: item?.log_id })}
                      onMouseLeave={() => this.setState({ hover: null })}
                    >
                      <div className="activity-log__item">
                        {['ENTITY_LOG', 'ADJUSTMENT_LOG']?.includes(item?.log_category) && (
                          <Fragment>
                            {(item.entity_name === 'product' || item.entity_name === 'sku_offer') ? (
                              <Fragment>
                                {(item?.entity_id === subEntityId || item.entity_name === 'sku_offer') && (
                                  <Fragment>
                                    {item?.description_details?.map(({ header, description }, index) => (
                                      <div key={index}>
                                        <H3Text
                                          text={header}
                                          className="activity-log__item-message"
                                        />
                                        {description && (
                                          <H3Text
                                            text={`"${description}"`}
                                            className="activity-log__item-message-subtext"
                                          />
                                        )}
                                      </div>
                                    ))}
                                  </Fragment>
                                )}
                                {item?.entity_id === entityId && item.entity_name !== 'sku_offer' && (
                                  <Fragment>
                                    {item?.description_details?.map(({ header, description }, index) => (
                                      <Fragment key={index}>
                                        {description && (
                                          <H3Text
                                            text={`"${description}"`}
                                            className="activity-log__item-message-subtext"
                                          />
                                        )}
                                      </Fragment>
                                    ))}
                                  </Fragment>
                                )}
                              </Fragment>
                            ) : (
                              <Fragment>
                                <H3Text
                                  text={item?.header}
                                  className="activity-log__item-message"
                                />
                                {item?.description && (
                                  <H3Text
                                    text={`"${item?.description}"`}
                                    className="activity-log__item-message-subtext"
                                  />
                                )}
                              </Fragment>
                            )}
                          </Fragment>
                        )}
                        {item?.log_category === 'APPROVAL_LOG' && (
                          <Fragment>
                            <H3Text
                              text={`${entityName ? entityName.toProperCase() : entityType?.replaceAll('_', ' ').toProperCase()} ${item?.action?.toProperCase()}`}
                              className="activity-log__item-message"
                            />
                            {item?.request?.rejection_reason && (
                              <H3Text
                                text={`"${item?.request?.rejection_reason}"`}
                                className="activity-log__item-message-subtext"
                              />
                            )}
                          </Fragment>
                        )}
                        {
                          item?.log_category === 'STATUS_LOG' && (
                            <Fragment>
                              <H3Text text="Status Changed" className="activity-log__item-message" />
                              <H3Text
                                text={(
                                  <div>
                                    From&nbsp;
                                    <span>{item?.prev_status?.replaceAll('_', ' ')}</span>
                                    &nbsp;
                                    to&nbsp;
                                    <span>{item?.status?.replaceAll('_', ' ')}</span>
                                  </div>
                                )}
                                className="activity-log__item-message-status-change"
                              />
                            </Fragment>
                          )
                        }
                        {
                          item?.log_category === 'CLOSING_STATUS_LOG' && (
                            <Fragment>
                              <H3Text text={item?.action?.toProperCase()} className="activity-log__item-message" />
                              <H3Text
                                text={(
                                  <div>
                                    Document has been marked <span> {item?.closing_status} </span>
                                  </div>
                                )}
                                className="activity-log__item-message-status-change"
                              />
                            </Fragment>
                          )
                        }
                        {
                          item?.log_category === 'DATE_CHANGE_LOG' && (
                            <Fragment>
                              <H3Text text={item?.action} className="activity-log__item-message" />
                              <H3Text
                                text={(
                                  <div>
                                    From&nbsp;
                                    <span>{item?.prev_status?.replaceAll('_', ' ')}</span>
                                    &nbsp;
                                    to&nbsp;
                                    <span>{item?.status?.replaceAll('_', ' ')}</span>
                                  </div>
                                )}
                                className="activity-log__item-message-status-change"
                              />
                            </Fragment>
                          )
                        }
                        {
                          item?.log_category === 'ENTITY_LOG' && (
                            <Fragment>
                              <H3Text
                                text={`${entityName ? entityName.includes("SKU Offer") ? entityName : entityName.toProperCase() : entityType?.replaceAll('_', ' ').toProperCase()} ${item?.action?.toProperCase()}`}
                                className={`activity-log__item-message`}
                              />
                              {((item?.action==='UPDATED') && (!!item?.update_document_reason)) && <H3Text text={`"${item?.update_document_reason}"`} className="activity-log__item-message-status-change" />}
                            </Fragment>
                          )
                        }
                        {
                          item?.log_category === 'COMMENT' && (
                            <div
                              className="activity-log__item-comment-wrapper"

                            >
                              <H3Image src={messageIcon2} className="activity-log__item-comment-icon" />
                              {edit !== item?.log_id && (
                                <H3Text
                                  text={(
                                    <React.Fragment>
                                      <span className="activity-log__item-message-subtext">
                                        {item?.message}

                                      </span>
                                      <H3Text
                                        text={item?.edited ? `edited by ${item?.modified_by_info?.first_name} on ${dayjs(item?.timestamp).format('MMM DD, YYYY hh:mm A')}` : `${item?.modified_by_info?.first_name} on ${dayjs(item?.timestamp).format('MMM DD, YYYY hh:mm A')}`}
                                        className="activity-log__item-user"
                                      />
                                    </React.Fragment>
                                  )}
                                  className="activity-log__item-comment"
                                />
                              )}

                              {hover === item?.log_id && edit !== item?.log_id && user?.user_id === item?.modified_by_info?.user_id && (
                                <div
                                  style={{
                                    marginLeft: 'auto', display: 'flex', justifyContent: 'space-evenly', gap: '10px',
                                  }}
                                >
                                  {item?.edited && (
                                    <React.Fragment>
                                      <Drawer
                                        open={setOpen}
                                        onClose={() => this.setState({ setOpen: false })}
                                        width="360px"
                                        destroyOnClose
                                      >
                                        <HistoryLog
                                          title="History Log"
                                          id={item?.log_id}
                                          entity_name={entityType}
                                          entity_id={entityId}
                                        />
                                      </Drawer>
                                    </React.Fragment>
                                  )}
                                </div>
                              )}
                              {edit === item?.log_id && (
                                <div className="activity-log__comment-edit-wrapper">
                                  <H3FormInput
                                    type="text"
                                    inputClassName="orgFormInput"
                                    containerClassName="activity-log__comment-edit-input"
                                    value={inputValue}
                                    onChange={(event) => this.setState({ inputValue: event.target.value })}
                                    placeholder="add comments here.."
                                    disabled={this.getActivityLogLoading() || editActivityLogLoading}
                                    onKeyUp={(e) => {
                                      if (e.key === 'Enter') this.editActivityLog(item?._id);
                                    }}

                                  />
                                  <Button
                                    onClick={() => {
                                      this.editActivityLog(item?._id);
                                    }}
                                    disabled={this.getActivityLogLoading() || editActivityLogLoading}
                                  >
                                    <RightSquareFilled />
                                  </Button>

                                </div>
                              )}

                            </div>
                          )
                        }
                        {item?.log_category !== 'COMMENT' && (
                          <H3Text
                            text={`${item?.modified_by_info?.first_name} on ${dayjs(item?.timestamp).format('MMM DD, YYYY hh:mm A')}`}
                            className="activity-log__item-user"
                          />
                        )}
                      </div>
                    </Timeline.Item>
                  ))
                }
              </Timeline>
              {this.getDataSource()?.count > 10 && this.getDataSource()?.data?.length < this.getDataSource()?.count && (
                <div
                  onClick={() => {
                    this.setState({ loadMore: true });
                    getActivityLog(entityId, entityType, page + 1, limit, () => {
                      this.setState({ page: page + 1 });
                    });
                  }}
                  className="view__activity-log__load-more"
                >
                  Load More
                  {' '}
                  {loadMore && this.getActivityLogLoading() ? <LoadingOutlined /> : <DownOutlined />}
                </div>
              )}
            </Fragment>
          ) : (
            <div className="no-logs-placeholder">
              {!this.getActivityLogLoading() && <Empty />}
            </div>
          )}
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ UserReducers, ActivityLogReducers }) => ({
  user: UserReducers.user,
  getActivityLogPRLoading: ActivityLogReducers.getActivityLogPRLoading,
  getActivityLogPILoading: ActivityLogReducers.getActivityLogPILoading,
  getActivityLogPOLoading: ActivityLogReducers.getActivityLogPOLoading,
  getActivityLogGRNLoading: ActivityLogReducers.getActivityLogGRNLoading,
  getActivityLogSOLoading: ActivityLogReducers.getActivityLogSOLoading,
  getActivityLogAMCLoading: ActivityLogReducers.getActivityLogAMCLoading,
  getActivityLogInvoiceLoading: ActivityLogReducers.getActivityLogInvoiceLoading,
  getActivityLogCOLoading: ActivityLogReducers.getActivityLogCOLoading,
  getActivityLogMOLoading: ActivityLogReducers.getActivityLogMOLoading,
  getActivityLogVendorPayoutLoading: ActivityLogReducers.getActivityLogVendorPayoutLoading,
  getActivityLogStockTransferLoading: ActivityLogReducers.getActivityLogStockTransferLoading,
  getActivityLogDebitNoteLoading: ActivityLogReducers.getActivityLogDebitNoteLoading,
  getActivityLogCreditNoteLoading: ActivityLogReducers.getActivityLogCreditNoteLoading,
  getActivityLogReturnSlipLoading: ActivityLogReducers.getActivityLogReturnSlipLoading,
  getActivityLogEstimateLoading: ActivityLogReducers.getActivityLogEstimateLoading,
  getActivityLogProductLoading: ActivityLogReducers.getActivityLogProductLoading,
  getActivityOfferLogProductLoading: ActivityLogReducers.getActivityOfferLogProductLoading,
  getActivityLogPackingSlipLoading: ActivityLogReducers.getActivityLogPackingSlipLoading,
  getActivityLogGateDocumentLoading: ActivityLogReducers.getActivityLogGateDocumentLoading,
  activityLogPR: ActivityLogReducers.activityLogPR,
  activityLogPI: ActivityLogReducers.activityLogPI,
  activityLogPO: ActivityLogReducers.activityLogPO,
  activityLogGRN: ActivityLogReducers.activityLogGRN,
  activityLogSO: ActivityLogReducers.activityLogSO,
  activityLogAMC: ActivityLogReducers.activityLogAMC,
  activityLogInvoice: ActivityLogReducers.activityLogInvoice,
  activityLogCO: ActivityLogReducers.activityLogCO,
  activityLogMO: ActivityLogReducers.activityLogMO,
  activityLogVendorPayout: ActivityLogReducers.activityLogVendorPayout,
  addActivityLogLoading: ActivityLogReducers.addActivityLogLoading,
  activityLogStockTransfer: ActivityLogReducers.activityLogStockTransfer,
  activityLogDebitNote: ActivityLogReducers.activityLogDebitNote,
  activityLogCreditNote: ActivityLogReducers.activityLogCreditNote,
  activityLogReturnSlip: ActivityLogReducers.activityLogReturnSlip,
  activityLogEstimate: ActivityLogReducers.activityLogEstimate,
  activityLogProduct: ActivityLogReducers.activityLogProduct,
  activityOfferLogProduct: ActivityLogReducers.activityOfferLogProduct,
  activityLogAPInvoice: ActivityLogReducers.activityLogAPInvoice,
  activityLogPackingSlip: ActivityLogReducers.activityLogPackingSlip,
  activityLogGateDocument: ActivityLogReducers.activityLogGateDocument,
  editActivityLogLoading: ActivityLogReducers.editActivityLogLoading,
  getHistoryActivityLogLoading: ActivityLogReducers.getHistoryActivityLogLoading,
  activityLogDeliveryChallan: ActivityLogReducers.activityLogDeliveryChallan,
  getActivityLogDeliveryChallanLoading: ActivityLogReducers.getActivityLogDeliveryChallanLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getActivityLog: (entityId, entityName, page, limit, callback, subEntityId) => dispatch(ActivityLogActions.getActivityLog(entityId, entityName, page, limit, callback, subEntityId)),
  getActivityLogSuccess: (activityLog) => dispatch(ActivityLogActions.getActivityLogSuccess(activityLog)),
  addActivityLog: (payload, callback) => dispatch(ActivityLogActions.addActivityLog(payload, callback)),
  editActivityLog: (payload, callback) => dispatch(ActivityLogActions.editActivityLog(payload, callback)),
  getHistoryActivityLog: (payload, callback) => dispatch(ActivityLogActions.getHistoryActivityLog(payload, callback)),
  getHistoryActivityLogSuccess: (payload) => dispatch(ActivityLogActions.getHistoryActivityLogSuccess(payload)),
});


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ActivityLog));
